/** C-05 고객정보 작업기록 화면의 비식별 정적 Mock 데이터입니다. */
export type LegacyCustomerHistoryRow = {
  no: number
  office: string
  workedAt: string
  staff: string
  customerNo: string
  oldCustomerNo: string
  baby: string
  parent: string
  father: string
  action: string
  contents: string
}

export const legacyCustomerHistoryOptions = {
  // 원본 선택 컨트롤의 항목 수(지점 25 / 작업자 18 / 항목 6)를 유지하되,
  // 운영 데이터와 무관한 비식별 Mock 이름만 사용한다.
  offices: Array.from({ length: 25 }, (_, index) => `데모지점 ${String(index + 1).padStart(2, '0')}`),
  staff: Array.from({ length: 18 }, (_, index) => `담당자 ${String(index + 1).padStart(2, '0')}`),
  actions: ['등록', '수정', '삭제', '상담', '계약', '메모'],
  pageLimits: ['30', '60', '100', '500', '1000'],
}

export const legacyCustomerHistoryRows: LegacyCustomerHistoryRow[] = Array.from({ length: 30 }, (_, index) => {
  const no = index + 1
  return {
    no,
    office: '데모지점 01',
    workedAt: `2026-08-${String(19 - (index % 12)).padStart(2, '0')} 10:${String(index).padStart(2, '0')}:00`,
    staff: legacyCustomerHistoryOptions.staff[index % legacyCustomerHistoryOptions.staff.length],
    customerNo: `C-HIS-${String(no).padStart(3, '0')}`,
    oldCustomerNo: '-',
    baby: `아기 ${no}`,
    parent: `고객 ${no}`,
    father: `보호자 ${no}`,
    action: legacyCustomerHistoryOptions.actions[index % legacyCustomerHistoryOptions.actions.length],
    contents: `Mock 고객정보 작업기록 ${no}`,
  }
})

export const legacyCustomerHistoryColumnWidths = [45, 55, 140, 100, 100, 80, 70, 70, 70, 50, 379]
